import React, { useEffect, useState } from "react";
import {
  FavoriteNonprofitsSection,
  FavoriteNonprofitsProfile,
  FavoriteNonprofitsRight,
  FavoriteNonprofitsTitle,
  NonprofitsFavorite,
} from "./favoriteNonprofitsStyle";

import Profile from "../../common/profile";
import SearchCard from "../../common/searchCard";
import { MESSAGE } from "../../../utils/message";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import SimpleLoader from "../simpleLoader/Loader";
import { userFavNonprofitsHandler } from "../../../redux/slices/myAccount/userFavoriteOrgs";
import { UserStateType } from "../../../utils/types";
import { userProfileStatesHandler } from "../../../redux/slices/myAccount/accountDetail-slice";

const FavoriteNonprofits = () => {
  const { user_id } = useParams();
  const [loader, setLoader] = useState(true);
  const nonprofitsData: any = useSelector(
    (state: any) => state?.userFavNonprofits?.data
  );

  const userStates = useSelector(
    (state: UserStateType) => state?.accountDetail?.userState?.results
  );
  const dispatch: any = useDispatch();

  useEffect(() => {
    if (!userStates && user_id) {
      dispatch(userProfileStatesHandler(user_id) as any);
    }
    if (user_id) {
      setLoader(true);
      dispatch(userFavNonprofitsHandler(user_id))
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
    }
  }, [dispatch,user_id]);

  return (
    <NonprofitsFavorite>
      <FavoriteNonprofitsTitle>
        {MESSAGE.myFavoriteNonprofits}
      </FavoriteNonprofitsTitle>
      {loader ? (
               <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <SimpleLoader />
               </div>
            ) : (
      <FavoriteNonprofitsSection>
        <FavoriteNonprofitsProfile>
          <Profile profileReviewData={userStates} />
        </FavoriteNonprofitsProfile>

        <FavoriteNonprofitsRight>
            {nonprofitsData?.results?.length > 0 ? (
              <SearchCard searchNonprofit={nonprofitsData?.results} refresh={()=>{dispatch(userFavNonprofitsHandler(user_id as string))}} name="remove" />
            ) : (
              <>
              <p>No favorites have been added to yet.</p> 
              <p>To add a favorite, go to an organization's profile or another person's favorites list and click "Add to Favorites" to follow your favorite nonprofits! You will then receive daily notifications when that organization gets new reviews.</p>
              </>
            )}
          </FavoriteNonprofitsRight>
      </FavoriteNonprofitsSection>
            )}
    </NonprofitsFavorite>
    
  );
};

export default FavoriteNonprofits;
